// Projects
import contact from "./src/contact.json"
import loader from "./src/loader.json"
import alto from "./src/projects/alto.json"
import factor from "./src/projects/factor.json"
import flirtagpt from "./src/projects/flirtagpt.json"
import sk from "./src/projects/sk.json"
import tapioca from "./src/projects/tapioca.json"
import tcmg4 from "./src/projects/tcmg4.json"
import type { ProjectData } from "./src/types"
import works from "./src/works.json"

const projects = [
  factor,
  alto,
  flirtagpt,
  tapioca,
  tcmg4,
  sk,
] as unknown as ProjectData[]

export { contact, loader, ProjectData, projects, works }
